import { useEffect, useState } from 'react';

import { AVATAR_SOURCES, AvatarSource } from './AvatarSources';
import { createImageObject } from './createImageObject';

interface ProbeState {
  src?: string;
  confirmedSrc?: string;
  loaded: boolean;
}

export const useHubSpotUserAvatarSrc = ({
  src,
  source,
}: {
  src?: string;
  source?: AvatarSource | null;
}) => {
  const isHubspotUserAvatar = !!(
    source === AVATAR_SOURCES.HUBSETTINGS_HUBSPOT_USER &&
    src?.includes('/transparent-default/')
  );

  const [probe, setProbe] = useState<ProbeState>({ loaded: false });

  useEffect(() => {
    if (!isHubspotUserAvatar || !src) {
      return undefined;
    }

    let isMounted = true;
    const img = createImageObject();
    img.onload = () => {
      if (isMounted) {
        setProbe({
          src,
          confirmedSrc: img.width !== 1 ? src : undefined,
          loaded: true,
        });
      }
    };
    img.onerror = () => {
      if (isMounted) {
        setProbe({ src, confirmedSrc: undefined, loaded: true });
      }
    };
    img.src = src;

    return () => {
      isMounted = false;
    };
  }, [src, isHubspotUserAvatar]);

  const probedCurrentSrc = probe.src === src;

  let resolvedSrc = src;
  if (isHubspotUserAvatar) {
    resolvedSrc = probedCurrentSrc ? probe.confirmedSrc : undefined;
  }

  const isHubspotUserAvatarLoaded = probedCurrentSrc && probe.loaded;

  return { isHubspotUserAvatar, resolvedSrc, isHubspotUserAvatarLoaded };
};
